import * as React from 'react'
const Modulbank = () => {
    return <div className="checkout-box-wrap checkout-box-details">
        <h2>Подтверждение принадлежности домена второго уровня. Усанова Гузель Рафаилевна</h2>
    </div>
}
export default Modulbank